import React from 'react';
import StepCard from './StepCard';
import { StepItem, AIRecommendationActions } from './types';

type VerticalStepperWithAIProps = {
  steps: StepItem[];
  activeKey?: string;
  onPrimaryAction?: (stepKey: string, actionType: AIRecommendationActions['primaryType']) => void;
  onSecondaryAction?: (stepKey: string, actionType: AIRecommendationActions['secondaryType']) => void;
  onRedirectAction?: (stepKey: string) => void;
};

const VerticalStepperWithAI: React.FC<VerticalStepperWithAIProps> = ({
  steps,
  activeKey,
  onPrimaryAction,
  onSecondaryAction,
  onRedirectAction,
}) => {
  return (
    <div className="space-y-4">
      {steps.map((step, index) => {
        const isActive = activeKey ? step.key === activeKey : index === steps.length - 1;
        return (
          <StepCard
            key={step.key}
            stepKey={step.stepKey}
            title={step.title}
            content={step.content}
            recommendation={step.recommendation}
            recommendationActions={step.recommendationActions}
            isActive={isActive}
            index={index + 1}
            badgeLabel={step.badgeLabel}
            onPrimaryAction={
              onPrimaryAction && step.recommendationActions
                ? (actionType) => onPrimaryAction(step.stepKey || step.key, actionType)
                : undefined
            }
            onSecondaryAction={
              onSecondaryAction && step.recommendationActions
                ? (actionType) => onSecondaryAction(step.stepKey || step.key, actionType)
                : undefined
            }
            onRedirectAction={
              onRedirectAction && step.recommendation ? () => onRedirectAction(step.stepKey || step.key) : undefined
            }
          />
        );
      })}
    </div>
  );
};

export default VerticalStepperWithAI;
